export default {
  'annotated-doc': {
    default: {w: 6, h: 64}
  },
  'bar-chart': {
    default: {w: 4, h: 32}
  },
  'base': {
    default: {w: 3, h: 32}
  },
  'control-panel': {
    default: {w: 4, h: 16}
  },
  'data-table': {
    default: {w: 12, h: 42}
  },
  'grouped-bar-chart': {
    default: {w: 4, h: 32}
  },
  'heatmap': {
    default: {w: 5, h: 32}
  },
  'histogram': {
    default: {w: 4, h: 32}
  },
  'line-chart': {
    default: {w: 4, h: 32}
  },
  'list': {
    default: {w: 3, h: 32, x: 0, y: 11}
  },
  'stats-bar': {
    default: {w: 12, h: 10, x: 0, y: 0}
  }
}
